import { InjectionToken } from '@angular/core';

import { Config } from '@core/types';

export const CONFIG_TOKEN = new InjectionToken<Config>('config');
